class SpiMasker {
    constructor() {
        this.REPLACE_PATTERNS = Object.freeze({
            ANY: /./g,
            ALPHANUMERIC: /[a-z\d]/gi,
        });
    }

    applyMask(val, pattern, type = "ANY") {
        const regex = new RegExp(pattern);
        const maskPattern = this.REPLACE_PATTERNS[type] || type;
        let maskedPortion;
        let maskedVal;

        if (regex.global) {
            const allMatches = [...val.matchAll(new RegExp(pattern))];

            if (allMatches.length) {
                maskedPortion = allMatches[0].input;
                maskedVal = maskedPortion;

                for (let i = 0; i < allMatches.length; i++) {
                    const match = allMatches[i][0];
                    const localMaskedVal = match.replace(maskPattern, "•");
                    maskedVal = maskedVal.replace(match, localMaskedVal);
                }
            } else {
                maskedPortion = val;
                maskedVal = maskedPortion.replace(maskPattern, "•");
            }

        } else {
            const match = val.match(new RegExp(pattern));
            maskedPortion = match?.length ? match[0] : val;
            maskedVal = maskedPortion.replace(maskPattern, "•");
        }

        return val.replace(maskedPortion, maskedVal);
    }

    email(val) {
        const localVal = val || "";
        const emailParts = localVal.split("@");
        const maskedPortion = emailParts.length ? emailParts[0] : "";
        let maskedVal;

        if (maskedPortion.length < 3) {
            maskedVal = this.applyMask(maskedPortion, /^.+$/);
        } else {
            const subStringPortion = maskedPortion.substring(1, maskedPortion.length - 1);
            const maskedSubstringVal = this.applyMask(subStringPortion, /^.+$/);
            maskedVal = `${maskedPortion.charAt(0)}${maskedSubstringVal}${maskedPortion.charAt(maskedPortion.length - 1)}`;
        }

        return localVal.replace(maskedPortion, maskedVal);
    }

    phone(val) {
        const localVal = val || "";
        const endSubstringIndex = localVal.length - (localVal.length === 10 ? 4 : 3);
        const subStringPortion = localVal.length >= endSubstringIndex
            ? localVal.substring(0, endSubstringIndex)
            : localVal.substring(0, localVal.length);
        const maskedSubstringVal = this.applyMask(subStringPortion, /[^-]+/g);
        return localVal.replace(subStringPortion, maskedSubstringVal);
    }

    dni(val) {
        const localVal = val || "";
        const endSubstringIndex = localVal.length - 3;
        const subStringPortion = localVal.length >= endSubstringIndex
            ? localVal.substring(0, endSubstringIndex)
            : localVal.substring(0, localVal.length);
        const maskedSubstringVal = this.applyMask(subStringPortion, /^.+$/);
        return localVal.replace(subStringPortion, maskedSubstringVal);
    }

    date(val) {
        const localVal = val || "";
        const maskedSubstringVal = this.applyMask(localVal, /[^-/\s]+/g);
        return localVal.replace(localVal, maskedSubstringVal);
    }

    cardNumber(val) {
        const localVal = val || "";
        const endSubstringIndex = localVal.length - 4;
        const subStringPortion = localVal.length >= endSubstringIndex
          ? localVal.substring(0, endSubstringIndex)
          : localVal.substring(0, localVal.length);
        const maskedSubstringVal = this.applyMask(subStringPortion, /[^-\s]+/g);
        return localVal.replace(subStringPortion, maskedSubstringVal);
    }

    cardHolderName(val) {
        const localVal = val || "";
        let maskedVal;

        maskedVal = this.applyMask(localVal, /[^\s]+/g);

        return localVal.replace(localVal, maskedVal);
    }

    cardCvv(val) {
        const localVal = val || "";
        let maskedVal;

        maskedVal = this.applyMask(localVal, /^.+$/);

        return localVal.replace(localVal, maskedVal);
    }
}

export default new SpiMasker();
